import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.data_aggregation_method_ */
export type DataAggregationMethodId = string & {
  __brand: 'DataAggregationMethodId'
}

/** Represents the table public.data_aggregation_method_ */
export default interface DataAggregationMethodTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<
    DataAggregationMethodId,
    DataAggregationMethodId,
    DataAggregationMethodId
  >

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type DataAggregationMethod = Selectable<DataAggregationMethodTable>

export type DataAggregationMethodInitializer =
  Insertable<DataAggregationMethodTable>

export type DataAggregationMethodMutator =
  Updateable<DataAggregationMethodTable>

export const dataAggregationMethodId =
  z.string() as unknown as z.Schema<DataAggregationMethodId>

export const dataAggregationMethod = z.object({
  id: dataAggregationMethodId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<DataAggregationMethod>

export const dataAggregationMethodInitializer = z.object({
  id: dataAggregationMethodId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<DataAggregationMethodInitializer>

export const dataAggregationMethodMutator = z.object({
  id: dataAggregationMethodId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<DataAggregationMethodMutator>
